<template>
  <div class="login-page company-landing">
    <div class="landing-page-edit-panel"
         v-if="isGM()">
      <div class="wrapper" :class="[{ 'active': landingPanel }]">
        <div class="landing-page-edit-settings" @click.prevent="landingPanel = !landingPanel"></div>
        <div v-if="editHistory === false">
          <div class="action-btn"
               @click.prevent.stop="pageMetaEdit = true">Edit page meta</div>
          <div class="action-btn"
               v-if="pageEditMode === false"
               @click.prevent="pageEditSwitch()">Edit page content</div>
          <div class="action-btn"
               @click.prevent="activateEditHistory()">Page edit history</div>
        </div>
        <div v-if="editHistory === true">
          <div class="form-group">
            <div class="form-element">
              <label for="page-versions" class="form-label color-2-63">Page save history</label>
              <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                        :searchable = false
                        @input="changeLandingPage($event)"
                        :options="getPageVersionsForSelect()"
                        data-lpignore="true"
                        id="page-versions" />
            </div>
          </div>
        </div>
        <div class="action-btn-bottom">
          <div class="action-btn action-btn-save"
               v-if="pageEditMode === true"
               @click.prevent="updateLandingPage()">Save</div>
          <div class="action-btn action-btn-discard"
               @click.prevent="discardPageEdit()">Discard</div>
        </div>
      </div>
    </div>
    <div class="wrapper" style="overflow: hidden;">
      <div class="landing-page-wrapper hero-section no-padding-top"
           v-show="!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())">
        <div class="landing-page-content">
          <div class="toggle-section-visibility"
               v-if="pageEditMode && isGM()">
            <input type="checkbox"
                   class="form-control__checkbox"
                   id="showHero"
                   v-model="content.heroSection.hideSection" />
            <label :for="'showHero'">Hide this section</label>
          </div>
          <div class="flex-section">
            <div class="left-content">
              <div class="inform-popup success"
                   id="information-message"
                   ref="informationMsg"
                   v-if="activatePage">
                <div class="inform-message-inner">
                  <div class="inform-title">
                    Your account was successfully activated.
                  </div>
                  <div class="inform-content">
                    Please use the temporary credentials from your invitation email to login.
                  </div>
                  <a href="#" v-on:click.prevent="closeCustomMsg()" class="inform-close"></a>
                </div>
              </div>
              <div class="hero-title">
                <span class="content color-2-100"
                      v-html="content.heroSection.title"
                      v-if="!pageEditMode">
                </span>
                <textarea class="content color-2-100"
                          v-if="pageEditMode && isGM()"
                          data-gramm_editor="false"
                          placeholder="Section title"
                          data-lpignore="true"
                          rows="1"
                          v-model="content.heroSection.title"
                          v-on:keydown="autoSize($event)">{{ content.heroSection.title }}</textarea>
              </div>
              <div class="hero-separator"></div>
              <div class="hero-login">
                <div class="landing-page-login-wrapper">
                  <form v-on:submit="authenticate()">
                    <div class="landing-page-login-wrapper">
                      <div class="tcc-form-group">
                        <label for="landing-page-login-email">Email address*</label>
                        <input id="landing-page-login-email"
                               class="tcc-form-element tcc-form-element__input"
                               :class="[{ 'border-1-50': loginForm.email !== '' || loginForm.emailFocus, 'not-empty': loginForm.email !== '' || loginForm.emailFocus, 'has-error': loginForm.isError || errors.has('Email address') }]"
                               type="email"
                               placeholder="Type in here..."
                               @focus="loginForm.emailFocus = true"
                               @blur="loginForm.emailFocus = false"
                               v-validate="'required|email'"
                               data-vv-name="Email address"
                               v-model="loginForm.email" />
                        <span class="form-field-error" v-if="this.errors.has('Email address')">{{ this.errors.first('Email address') }}</span>
                      </div>
                      <div class="tcc-form-group">
                        <label for="landing-page-login-password">Password*</label>
                        <span class="landing-page-login-password-show"
                              @click.prevent="showPassword()"></span>
                        <input id="landing-page-login-password"
                               class="tcc-form-element tcc-form-element__input"
                               placeholder="Type in here..."
                               :class="[{ 'border-1-50': loginForm.password !== '' || loginForm.passwordFocus, 'not-empty': loginForm.password !== '' || loginForm.passwordFocus, 'has-error': loginForm.isError || errors.has('Password') }]"
                               :type="loginForm.passwordType"
                               @focus="loginForm.passwordFocus = true"
                               @blur="loginForm.passwordFocus = false"
                               v-validate="'required'"
                               data-vv-name="Password"
                               v-model="loginForm.password" />
                        <span class="form-field-error" v-if="this.errors.has('Password')">{{ this.errors.first('Password') }}</span>
                      </div>
                      <div class="landing-page-login-actions">
                        <button type="submit" class="login background-1-100"
                                :class="[{ 'active-logging': formStatus.submitting }]"
                                @click.prevent="authenticate('top')">Login</button>
                        <router-link :to="{ name: 'forgot-password' }" class="reset-password">Forgot password?</router-link>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="landing-page-login-footer">
                  <div class="landing-page-login-footer__top">
                    Don't have an account? <router-link to="/register">Sign up here</router-link>.
                  </div>
                  <div class="landing-page-login-footer__bottom">
                    Struggling with something? Tell us about it <router-link to="/need-help">here</router-link>.
                  </div>
                </div>
                <div class="tcc-form-message"
                     aria-live="assertive">
                  <div v-if="this.formStatus.submitting" class="visually-hidden">
                    Submitting
                  </div>
                  <template v-else>
                    <template v-if="formStatus.shown">
                      <h2 v-if="formStatus.title !== ''">
                        <template v-if="formStatus.success">
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-envelope" class="svg-inline--fa fa-circle-envelope" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM384 320c0 17.67-14.33 32-32 32H160c-17.67 0-32-14.33-32-32V238l122.1 48.82C251.1 287.6 253.1 288 256 288s4.031-.375 5.938-1.141L384 238V320zM384 203.6l-128 51.2L128 203.6V192c0-17.67 14.33-32 32-32h192c17.67 0 32 14.33 32 32V203.6z"></path>
                          </svg>
                        </template>
                        <template v-else>
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-xmark" class="svg-inline--fa fa-circle-xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"></path>
                          </svg>
                        </template>
                        {{ formStatus.title }}
                      </h2>
                      <p v-if="formStatus.body !== ''">
                        {{ formStatus.body }}
                      </p>
                    </template>
                    <template v-else-if="this.errors.items && this.errors.items.length">
                      <h2>
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-exclamation" class="svg-inline--fa fa-circle-exclamation" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"></path>
                        </svg>
                        Some fields are missing.
                      </h2>
                      <p>Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.</p>
                    </template>
                  </template>
                </div>
              </div>
            </div>
            <div class="right-content">
              <div class="hero-image">
                <div class="content"
                     :title="content.heroSection.altImage"
                     v-bind:style="{ backgroundImage: getImage(content.heroSection.image) }">
                  <input type="text"
                         placeholder="Alt image"
                         v-if="pageEditMode && isGM()"
                         class="landing-page-image-alt"
                         v-model="content.heroSection.altImage" />
                  <label :for="'hero-image-upload'"
                         v-if="pageEditMode && isGM()"
                         class="hero-upload"></label>
                  <input type="file"
                         v-if="pageEditMode && isGM()"
                         @change="onFileChange($event, content.heroSection, 'image')"
                         :id="'hero-image-upload'" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="landing-page-wrapper contact-cta-section"
           v-show="!content.contactCTA.hideSection || content.contactCTA.hideSection === 'null' || (pageEditMode && isGM())">
        <div class="landing-page-content">
          <div class="toggle-section-visibility"
               v-if="pageEditMode && isGM()">
            <input type="checkbox"
                   class="form-control__checkbox"
                   id="showContactCTA"
                   v-model="content.contactCTA.hideSection" />
            <label :for="'showContactCTA'">Hide this section</label>
          </div>
        </div>
        <div class="contact-cta">
          <div class="contact-cta--content">
            <div class="contact-cta--content__title">
              <h1 class="content"
                  v-html="content.contactCTA.title"
                  v-if="!pageEditMode"></h1>
              <textarea class="content"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.contactCTA.title"
                        v-on:keydown="autoSize($event)">{{ content.contactCTA.title }}</textarea>
            </div>
<!--            <div class="contact-cta&#45;&#45;content__text">
              <p class="content"
                 v-html="content.contactCTA.text"
                 v-if="!pageEditMode"></p>
              <textarea class="content"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Text"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.contactCTA.text"
                        v-on:keydown="autoSize($event)">{{ content.contactCTA.text }}</textarea>
            </div>-->
            <div class="contact-cta--actions" :class="pageEditMode ? 'edit-mode' : ''">
              <template v-for="button in content.contactCTA.buttons">
                <template v-if="pageEditMode">
                  <div class="form-group">
                    <div class="form-element form-element--half">
                      <label for="page-versions" class="form-label color-2-63">Button text</label>
                      <input type="text"
                             class="form-control form-control__input"
                             v-model="button.text" placeholder="Button text" />
                    </div>
                    <div class="form-element form-element--half">
                      <label for="page-versions" class="form-label color-2-63">Button link</label>
                      <input type="text"
                             class="form-control form-control__input"
                             v-model="button.link" placeholder="Button link" />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <a :href="button.link">{{ button.text }}</a>
                </template>
              </template>
              <div class="clearfix"></div>
              <div class="landing-page-add-section"
                   v-if="pageEditMode"
                   @click.prevent="addSection('contact-cta-button')">+ Add button</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-change-image" ref="pageMetaPopup" v-if="pageMetaEdit && isGM()">
      <div class="modal-inner" ref="metaEditPopup">
        <h1>Change page meta</h1>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="popup-footer-edit">
          <div>
            <div class="meta-description">
              <label for="meta-title">Title</label>
              <input id="meta-title"
                     placeholder="Page meta title"
                     v-model="metaData.title" />
            </div>
            <div class="meta-description">
              <label for="meta-description">Description</label>
              <textarea id="meta-description"
                        placeholder="Page meta description"
                        v-model="metaData.description">{{ metaData.description }}</textarea>
            </div>
          </div>
        </div>
        <div class="popup-actions">
          <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
          <a href="#" @click.prevent="updateMeta()" class="submit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'

export default {
  name: 'login',
  data () {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      loginForm: {
        email: '',
        password: '',
        grantType: 'password',
        clientId: '2_659vq9a3czggcws88wcws8s4kc8gc8gcss4wog4cwcsk08ggkg',
        clientSecret: '5ncmjzrt9ps8808cskk8ogwwgwkgks8ggc0kskg0cw48s08ks4',
        emailFocus: false,
        passwordFocus: false,
        isError: false,
        passwordType: 'password'
      },
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: '',
          hideSection: false
        },
        contactCTA: {
          title: '',
          text: '',
          buttons: [
            {
              text: '',
              link: ''
            }
          ],
          hideSection: false
        }
      },
      activatePage: false
    }
  },
  computed: {
    ...mapGetters([
      'getIsLoggedIn',
      'getUserRole',
      'selectedHightCont',
      'getSelectedFontSize'
    ])
  },
  methods: {
    ...mapActions([
      'redirect'
    ]),
    closeCustomMsg () {
      this.activatePage = false
      let query = Object.assign({}, this.$route.query)
      delete query.activated
      this.$router.replace({ query })
    },
    updateLandingPage () {
      if (this.disableAPI) return
      let body = JSON.stringify(this.content)
      let pageData = {
        slug: 'login-page',
        body: body
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.getLandingPage(null, true)
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    updateMeta () {
      if (this.disableAPI) return
      let metaTitle = this.metaData.title
      let metaDescription = this.metaData.description
      let pageData = {
        title: metaTitle,
        slug: 'login-page',
        description: metaDescription
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        document.location.reload()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getLandingPage (id, refresh) {
      if (this.disableAPI) return
      this.disableAPI = true
      let body = {
        slug: 'login-page'
      }
      if (id) {
        body.id = id
      }
      this.$http.post(api.URLS.staticpage + '/login-page', body, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        let pageData = JSON.parse(res.data.body)
        this.content = {...this.content, ...pageData}
        this.metaData.title = res.data.title
        this.metaData.description = res.data.description
        if (this.metaData.title && this.metaData.title !== '') {
          document.title = this.metaData.title + ' | Clear Assured'
        }
        this.addPageMeta('description', [{name: 'content', value: this.metaData.description}])
        this.content.title = this.metaData.title
        this.content.description = this.metaData.description
        if (id) {
          this.pageEditSwitch()
        } else {
          if (refresh) {
            this.pageEditMode = false
          }
        }
        this.$store.commit('setUserDimensions')
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname])
          window._paq.push(['setDocumentTitle', document.title])
          window._paq.push(['trackPageView'])
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
        this.$nextTick(() => {
          this.heroImageHeightFix()
        })
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getPageVersions () {
      let self = this
      if (this.disableAPI) return
      this.disableAPI = true
      this.$http.get(api.URLS.staticpagechanges + '/login-page', api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.pageVersions = []
        for (let index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          })
        }
        this.editHistory = true
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    activateEditHistory () {
      this.getPageVersions()
    },
    getPageVersionsForSelect () {
      return this.pageVersions
    },
    changeLandingPage (el) {
      this.getLandingPage(el.id)
    },
    convertDateTime (payload) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let ampm = hours >= 12 ? 'PM' : 'AM'
      let newHours = hours % 12 ? hours % 12 : 12
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      let dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear
      let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
      return dateString + ' ' + timeString
    },
    addPageMeta (name, data) {
      let meta = document.createElement('meta')
      meta.name = name
      for (let index in data) {
        meta.setAttribute(data[index].name, data[index].value)
      }
      document.getElementsByTagName('head')[0].appendChild(meta)
    },
    discardChanges () {
      this.getLandingPage(null, true)
    },
    pageEditSwitch () {
      this.pageEditMode = true
      this.$nextTick(() => {
        this.autoSizeOnInit()
      })
    },
    discardPageEdit () {
      this.discardChanges()
      if (this.editHistory) {
        this.editHistory = false
      } else {
        this.landingPanel = false
      }
    },
    authenticate () {
      if (this.disableAPI) return
      this.formStatus.submitting = true
      this.$validator.validateAll(['Email address', 'Password']).then((valid) => {
        if (!valid) {
          this.formStatus.submitting = false
          this.heroImageHeightFix()
          return
        }
        let auth = {
          grant_type: this.loginForm.grantType,
          client_id: this.loginForm.clientId,
          client_secret: this.loginForm.clientSecret,
          username: this.loginForm.email,
          password: this.loginForm.password
        }
        this.$http.post(api.URLS.login, auth).then((res) => {
          let headers = {headers: {'Authorization': `Bearer ${res.body.access_token}`}}
          document.cookie = 'Recite.Persist=; Max-Age=-99999999;'
          localStorage.setItem('token', res.body.access_token)
          this.$http.put(api.URLS.profile, {}, headers)
            .then((res) => {
              let userData = {
                'id': res.body.id ? res.body.id : '',
                'firstName': res.body.first_name ? res.body.first_name : '',
                'lastName': res.body.last_name ? res.body.last_name : '',
                'userRole': res.body.role.slug,
                'company': res.body.company ? res.body.company.id : null
              }
              if (['ca', 'gm'].indexOf(res.body.role.slug) > -1 && res.body.consent_status === 0) {
                localStorage.setItem('consentHead', 'true')
              }
              localStorage.setItem('consentSeen', res.body.consent_seen)
              localStorage.setItem('userData', JSON.stringify(userData))
              localStorage.setItem('cookieFixed', true)
              localStorage.setItem('userIndustry', (res.body.company && res.body.company.industry) ? res.body.company.industry.id : 1)
              document.getElementById('app').setAttribute('data-industry', (res.body.company && res.body.company.industry) ? res.body.company.industry.id : 1)
              if (res.body.company) {
                localStorage.setItem('userCompanyName', res.body.company.name)
              }
              if (res.body.company && res.body.company.industry) {
                localStorage.setItem('userIndustryName', res.body.company.industry.name)
              }
              this.$store.commit('authLoginSuccess')
              if (res.body.company && res.body.company.is_temporary) {
                let props = this.$router.resolve({
                  name: 'complete-profile'
                })
                location.href = props.href
              } else {
                this.redirect()
              }
              // this.$store.commit('authLoginSetUsername', userData.firstName)
            })
            .catch((err) => {
              if (err.status === 401) {
                localStorage.removeItem('token')
                localStorage.removeItem('userData')
                localStorage.removeItem('consentSeen')
                localStorage.removeItem('consentHead')
                localStorage.removeItem('userIndustryName')
                localStorage.removeItem('userCompanyName')
                this.loginForm.isError = true
                this.formStatus.submitting = false
                this.formStatus.shown = true
                this.formStatus.success = false
                this.formStatus.title = 'Your account is inactive. Please contact support.'
                this.formStatus.body = 'It looks like there was an error. Please try again or give us a call and we’ll have our support team help you.'
                this.heroImageHeightFix()
              }
            })
        }).catch(() => {
          this.loginForm.isError = true
          this.formStatus.submitting = false
          this.formStatus.shown = true
          this.formStatus.success = false
          this.formStatus.title = 'Invalid credentials'
          this.formStatus.body = 'It looks like there was an error. Please try again or give us a call and we\'ll have our support team help you.'
          this.heroImageHeightFix()
        })
      })
    },
    addSection (section) {
      if (section === 'contact-cta-button') {
        this.content.contactCTA.buttons.push({
          text: '',
          link: ''
        })
      }
    },
    removeSection (section, index) {
      section.splice(index, 1)
    },
    showPassword () {
      this.loginForm.passwordType = this.loginForm.passwordType === 'password' ? 'text' : 'password'
    },
    decodeHtml (value) {
      var txt = document.createElement('textarea')
      txt.innerHTML = value
      return txt.value
    },
    autoSize (el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0'
        el.target.style = 'height:' + el.target.scrollHeight + 'px'
      }, 0)
    },
    autoSizeOnInit () {
      let textAreas = document.getElementsByTagName('textarea')
      for (let i = 0; i < textAreas.length; i++) {
        let item = textAreas[i]
        setTimeout(function () {
          item.style = 'height:auto; padding:0'
          item.style = 'height:' + item.scrollHeight + 'px'
        }, 0)
      }
    },
    encodeHtml (rawStr) {
      return rawStr.replace(/[\u00A0-\u9999<>]/gim, function (i) {
        return '&#' + i.charCodeAt(0) + ';'
      })
    },
    isGM () {
      let isLogged = this.getIsLoggedIn
      if (!isLogged) {
        return false
      }
      let userRole = this.getUserRole
      if (userRole === 'gm') {
        return true
      }
      return false
    },
    onFileChange (e, target, item) {
      var input = e.target
      let self = this
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader()
        reader.onload = function (e) {
          let fileName = input.files[0].name
          let extension = fileName.split('.').pop().toLowerCase()
          if (self.disableAPI) return
          let pageData = {
            file: e.target.result,
            extension: extension
          }
          self.disableAPI = true
          self.$http.post(api.URLS.uploadFile, pageData, api.headersAuthSettings).then((res) => {
            self.disableAPI = false
            target[item] = res.body
          }).catch((err) => {
            self.disableAPI = false
            console.log('err', err)
          })
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    getImagePath () {
      return api.serverURL + '/uploads/images/content/'
    },
    isBase64 (payload) {
      return payload.indexOf('data:') !== -1
    },
    getImage (payload) {
      if (!payload) {
        return ''
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')'
    },
    getImageFullPath (payload) {
      if (!payload) {
        return ''
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload
    },
    closePopup () {
      this.pageMetaEdit = false
    },
    closePopupOnOutsideClick (e) {
      let pageMetaPopup = this.$refs.pageMetaPopup
      let target = e.target
      if (pageMetaPopup && pageMetaPopup !== target && !pageMetaPopup.contains(target)) {
        this.closePopup()
      }
    },
    heroImageHeightFix () {
      let imageContainer = document.querySelector('.hero-section .right-content')
      let image = document.querySelector('.hero-section .hero-image')
      let header = document.querySelector('header')
      let maxHeight = window.innerHeight
      if (header) {
        maxHeight -= header.offsetHeight
      }
      if (imageContainer && image && (image.clientHeight < maxHeight || imageContainer.clientHeight < maxHeight)) {
        imageContainer.style.height = `${maxHeight}px`
        image.style.maxHeight = `${maxHeight}px`
      }
    }
  },
  beforeMount () {
    this.getLandingPage()
  },
  mounted () {
    document.addEventListener('click', this.closePopupOnOutsideClick)
    window.addEventListener('resize', this.heroImageHeightFix)
    this.activatePage = this.$route.query.activated
    if (this.$route.name === 'edit-login') {
      this.pageEditMode = true
      this.landingPanel = true
    }
  },
  beforeDestroy () {
    document.addEventListener('click', this.closePopupOnOutsideClick)
    window.removeEventListener('resize', this.heroImageHeightFix)
  },
  watch: {}
}
</script>

<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>
<style src="@/assets/scss/main/company-landing.scss" lang="scss" scoped></style>
<style src="@/assets/scss/main/homepage.scss" lang="scss" scoped></style>

<style lang="scss" scoped>
  .inform-popup {
    margin-top: 2.5rem;
    margin-bottom: 0;
    & + .hero-title {
      padding-top: 2rem !important;
    }
  }
</style>



// WEBPACK FOOTER //
// Login.vue?166ecd12